import React, { useEffect, useState } from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './reward.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { FormText, FormSelect, TextArea, SelectizeField, FormNumber } from '~/components/FormControl';
import { Formik } from 'formik';
import { Card, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { fetchCardMetaDataApi } from '~/pages/CardSaga/cardMetaDataSlice';
import { ITEMS } from '~/config/constants';
import { fetchHeroApi } from '~/pages/HeroSaga/Hero/heroSlice';
import { fetchFamiliarApi } from '~/pages/HeroSaga/Familiar/familiarSlice';
import { fetchGearApi } from '../Gear/gearSlice';
import { fetchArtifactApi } from '../Artifact/artifactSlice';
import { fetchHeroSkinApi } from '../HeroSkin/heroSkinSlice';
import { fetchDiceSkinApi } from '../DiceSkin/diceSkinSlice';
import { fetchCardSkinApi } from '../CardSkin/cardSkinSlice';
import { fetchEmoteApi } from '../Emote/emoteSlice';
import { fetchPlayerIconApi } from '../PlayerIcon/playerIconSlice';
import { fetchConsumableApi } from '../Consumable/consumableSlice';
import { fetchItemApi } from '../Item/itemSlice';
import { fetchLootBoxApi } from '../LootBox/lootBoxSlice';

RewardForm.defaultProps = {
    pictureAttributeNames: null,
};
RewardForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    setResetCount: PropTypes.func.isRequired,
    pictureAttributeNames: PropTypes.array,
    resetCount: PropTypes.number.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

function RewardForm({ initialValues, setResetCount, pictureAttributeNames, resetCount, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);
    const { cardMetaData } = useSelector((state) => state.cardSaga.cardMetaData);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (isEmpty(cardMetaData)) {
            dispatch(fetchCardMetaDataApi(navigate));
        }
    }, []);

    return (
        <>
            {/* MUST put `isEmpty(rewardMetaData)` in condition, else Bootstrap `Select` will not display value to UI (even though it's already stored value in it)  */}
            {!isEmpty(initialValues) && !isEmpty(cardMetaData) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={initialValues.id === null ? schema : schema(true)}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm, values } = props;

                                const [pool, setPool] = useState([]);
                                const hero = useSelector((state) => state.heroSaga.hero);
                                const familiar = useSelector((state) => state.heroSaga.familiar);
                                const gear = useSelector((state) => state.itemSaga.gear);
                                const artifact = useSelector((state) => state.itemSaga.artifact);
                                const heroSkin = useSelector((state) => state.itemSaga.heroSkin);
                                const diceSkin = useSelector((state) => state.itemSaga.diceSkin);
                                const cardSkin = useSelector((state) => state.itemSaga.cardSkin);
                                const emote = useSelector((state) => state.itemSaga.emote);
                                const playerIcon = useSelector((state) => state.itemSaga.playerIcon);
                                const consumable = useSelector((state) => state.itemSaga.consumable);
                                const item = useSelector((state) => state.itemSaga.item);
                                const lootBox = useSelector((state) => state.itemSaga.lootBox);

                                useEffect(() => {
                                    setPool(hero.rows);
                                }, [hero]);
                                useEffect(() => {
                                    setPool(familiar.rows);
                                }, [familiar]);
                                useEffect(() => {
                                    setPool(gear.rows);
                                }, [gear]);
                                useEffect(() => {
                                    setPool(artifact.rows);
                                }, [artifact]);
                                useEffect(() => {
                                    setPool(heroSkin.rows);
                                }, [heroSkin]);
                                useEffect(() => {
                                    setPool(diceSkin.rows);
                                }, [diceSkin]);
                                useEffect(() => {
                                    setPool(cardSkin.rows);
                                }, [cardSkin]);
                                useEffect(() => {
                                    setPool(emote.rows);
                                }, [emote]);
                                useEffect(() => {
                                    setPool(playerIcon.rows);
                                }, [playerIcon]);
                                useEffect(() => {
                                    setPool(consumable.rows);
                                }, [consumable]);
                                useEffect(() => {
                                    setPool(item.rows);
                                }, [item]);
                                useEffect(() => {
                                    setPool(lootBox.rows);
                                }, [lootBox]);

                                const fetchItem = (item) => {
                                    switch (item) {
                                        case 'hero':
                                            dispatch(fetchHeroApi(navigate));
                                            break;
                                        case 'familiar':
                                            dispatch(fetchFamiliarApi(navigate));
                                            break;
                                        case 'gear':
                                            dispatch(fetchGearApi(navigate));
                                            break;
                                        case 'artifact':
                                            dispatch(fetchArtifactApi(navigate));
                                            break;
                                        case 'hero_skin':
                                            dispatch(fetchHeroSkinApi(navigate));
                                            break;
                                        case 'dice_skin':
                                            dispatch(fetchDiceSkinApi(navigate));
                                            break;
                                        case 'card_skin':
                                            dispatch(fetchCardSkinApi(navigate));
                                            break;
                                        case 'emote':
                                            dispatch(fetchEmoteApi(navigate));
                                            break;
                                        case 'player_icon':
                                            dispatch(fetchPlayerIconApi(navigate));
                                            break;
                                        case 'consumable':
                                            dispatch(fetchConsumableApi(navigate));
                                            break;
                                        case 'item':
                                            dispatch(fetchItemApi(navigate));
                                            break;
                                        case 'loot_box':
                                            dispatch(fetchLootBoxApi(navigate));
                                            break;
                                        default:
                                    }
                                }

                                useEffect(() => {
                                    fetchItem(values.item);
                                }, [values]);

                                const onChangeItem = (item) => {
                                    fetchItem(item);
                                }

                                return (
                                    <>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <Form.Row className="d-flex justify-content-between">
                                            <TextArea
                                                name={'description'}
                                                sm={3}
                                                rows={4}
                                            />
                                            <FormSelect
                                                name="item"
                                                options={ITEMS}
                                                sm={3}
                                                label="Item"
                                                onChangeValue={(from, value) => onChangeItem(value)}
                                            />
                                            <SelectizeField
                                                name="pool"
                                                options={pool}
                                                sm={3}
                                                label="Pool"
                                            // note={notes[i]}
                                            // setReplacements={(arr) => setDrop(arr, i)}
                                            />
                                        </Form.Row>
                                        <Form.Row className="d-flex justify-content-between">
                                            <FormNumber
                                                name={'rate'}
                                                label="Rate"
                                                sm={3}
                                            />
                                            <FormNumber
                                                name={'min_quantity'}
                                                label="Min quantity"
                                                sm={3}
                                            />
                                            <FormNumber
                                                name={'max_quantity'}
                                                label="Max quantity"
                                                sm={3}
                                            />
                                        </Form.Row>

                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

export default RewardForm;
